import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['menu'];

  connect() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.close();
  }

  disconnect() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.element.contains(event.target)) return;
    this.close();
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    this.menuTarget.classList.toggle('hidden');
  }

  close() {
    this.menuTarget.classList.add('hidden');
  }
}
